import { Outlet } from 'react-router-dom';
import { styled } from '@mui/material/styles';

// material-ui
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { Container } from '@mui/material';

// project imports
import HeaderOutlet from 'layout/MainLayout/Header';
import FooterOutlet from 'layout/MainLayout/Footer';

const Body = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    // minWidth: '25rem',
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.background.default : theme.palette.primary.light
}));

const Header = styled('div')(({ theme }) => ({
    flexGrow: 0,
    flexShrink: 0,
    flexBasis: 'auto',
    backgroundColor: theme.palette.background.default,
    borderBottom: '1px solid',
    borderColor: theme.palette.mode === 'dark' ? theme.palette.dark.dark : theme.palette.grey[200],
    color: theme.palette.text.dark
}));

const Footer = styled('div')(({ theme }) => ({
    flexGrow: 0,
    flexShrink: 0,
    flexBasis: 'auto'
}));

const MainContainer = styled(Container)(({ theme }) => ({
    flexGrow: 1,
    flexShrink: 0,
    flexBasis: 'auto',
    minHeight: 0,
    padding: '0 20px 0 20px',
    display: 'flex',
    flexDirection: 'column'
}));


const MainLayout = () => {
    const theme = useTheme();
    const mdDown = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <Body>
            <Header>
                <HeaderOutlet />
            </Header>

            <MainContainer disableGutters={mdDown} sx={{padding: '0 20px 0 20px'}}>
                <Outlet />
            </MainContainer>

            <Footer>
                <Container disableGutters={mdDown} sx={{padding: '0 20px 0 20px'}}>
                    <FooterOutlet />
                </Container>
            </Footer>
        </Body>
    );
};

export default MainLayout;
